import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable, map } from 'rxjs'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { AppState } from 'src/app/store/state/app.state'
import { Store } from '@ngrx/store'
import { UserDashboardAPIModel } from '../../models/api.model'

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  getUserDashboard(): Observable<UserDashboardAPIModel> {
    return this.webService.get(ServiceUrlConstants.API_DASHBOARD).pipe(map((data: any) => data))
  }

  getEmpDashboardSelect(): Observable<any> {
    return this.appState.select('dashboard')
  }
}
